import './SocialShareButtons.css';

function SocialShareButtons({ title, url }) {
  const handleShare = (platform) => {
    const shareUrl = url || window.location.href;
    const text = encodeURIComponent(title);
    
    let shareLink = '';
    switch(platform) {
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'twitter':
        shareLink = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'whatsapp':
        shareLink = `https://wa.me/?text=${text}%20${encodeURIComponent(shareUrl)}`;
        break;
      default:
        return;
    }
    
    window.open(shareLink, '_blank', 'width=600,height=400');
  };

  return (
    <div className="social-share-buttons">
      <h4>Condividi questo articolo:</h4>
      <div className="social-share">
        <button 
          className="share-btn facebook"
          onClick={() => handleShare('facebook')}
        >
          <i className="fa-brands fa-facebook"></i> Facebook
        </button>
        <button 
          className="share-btn twitter"
          onClick={() => handleShare('twitter')}
        >
          <i className="fa-brands fa-x-twitter"></i> Twitter
        </button>
        <button 
          className="share-btn whatsapp"
          onClick={() => handleShare('whatsapp')}
        >
          <i className="fa-brands fa-whatsapp"></i> WhatsApp
        </button>
      </div>
    </div>
  );
}

export default SocialShareButtons;
